export var SKILLS_ROOT_ID = 'skills-report-dashboard';
export var FILTER_INPUT_ID = 'help-needed-filter';
export var zIndexes = {
    tableHead: 10,
    innerTableTooltip: 9,
};
